const handler = ( $ ) => {
	// disable autocomplete
	$( 'form, input, textarea' )
		.attr( 'autocomplete', 'off' )
		.attr( 'spellcheck', 'false' )
		.attr( 'autocorrect', 'off' );

	// responsive frames
	$( '#content iframe' )
		.not( '.gform_wrapper + iframe' )
		.each( function () {
			const $iframe = $( this );

			if ( ! $iframe.parent().hasClass( 'embed-container' ) ) {
				$iframe.wrap( '<div class="embed-container"></div>' );
			}
		} );

	// responsive tables
	$( 'table' ).wrap( '<div class="responsive-table"></div>' );

	// Selectric
	$( 'select' ).selectric( {
		disableOnMobile: false,
		nativeOnMobile: false,
	} );

	// Scroll to anchor bug fix
	const isChrome =
		/Chrome/.test( navigator.userAgent ) &&
		/Google Inc/.test( navigator.vendor );

	if ( window.location.hash && isChrome ) {
		setTimeout( () => {
			const hash = window.location.hash;
			window.location.hash = '';
			window.location.replace( hash );
		}, 300 );
	}
};

( ( $ ) => {
	$( handler );
} )( jQuery );
